import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticles() {
  const hotArticles = articles.slice(0, 3);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-[1440px]">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            热门精选
          </h2>
          <p className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight mt-3">
            本周最热吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-full h-[220px] md:h-[260px] overflow-hidden bg-background-100 relative">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`黑料入口 ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.isHot && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-white text-xs font-medium whitespace-nowrap">
                    热门
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-serif text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-3">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-foreground-400">·</span>
                  <div className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs text-foreground-400"></i>
                    <span className="text-xs text-foreground-500">
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-10">
          <Link
            to="/category/reshi-zhui"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300/40 text-sm font-medium text-foreground-700 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多热门
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}